import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ReviewLayout from '../Practice/PracticeReview/ReviewLayout';
import ConceptualizationReport from '../Practice/PracticeReview/ConceptualizationReport';
import { getAiClientConceptualization } from './myPageApi';
import { toReviewSession } from './aiClientActivity';
import '../Practice/AIClients/AIClients.css';
import './MyPage.css';

// 마이페이지 활동 이력에서 연 사례개념화 피드백 화면. GET /api/mypage/ai-client-activity/:instanceId/conceptualization
export default function AiClientConceptualizationPage() {
    const { instanceId } = useParams();
    const { state } = useLocation();
    const [result, setResult] = useState(undefined);
    const [error, setError] = useState('');

    // 사례개념화를 불러와 상태에 넣는다. 작성하지 않은 면담이면 null.
    const load = useCallback(async () => {
        setError('');
        setResult(undefined);
        try {
            setResult(await getAiClientConceptualization(instanceId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [instanceId]);

    useEffect(() => { load(); }, [load]);

    const backLink = <Link className="my-page-back-link" to="/mypage/activity">← 활동 이력으로</Link>;

    if (error || !result) return <div className="ai-clients-page my-page"><div className="ai-clients-wrap">
        {backLink}
        {error && <div className="my-page-card my-page-placeholder" role="alert"><h3>사례개념화를 불러오지 못했습니다</h3><p>{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div>}
        {!error && result === null && <div className="my-page-card my-page-placeholder"><h3>사례개념화 기록이 없습니다</h3><p>이 면담에서 작성하고 저장한 사례개념화가 없습니다.</p></div>}
        {!error && result === undefined && <p className="my-page-notice" role="status">사례개념화를 불러오고 있습니다.</p>}
    </div></div>;

    // 목록에서 넘어오지 않고 주소로 바로 들어온 경우 내담자 정보 없이 보여준다.
    return <>
        <div className="my-page-back-bar">{backLink}</div>
        <ReviewLayout session={toReviewSession(state?.activity)}><ConceptualizationReport result={result} /></ReviewLayout>
    </>;
}
